import { routerConfig } from "./routerConfig"
import { Suspense } from "react"
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom"
import { Layout } from "@/app/Layout"

const Routers = () => {
	const location = useLocation()

	return (
		<Routes location={location} key={location.pathname}>
			<Route element={<Layout />}>
				{routerConfig.routes.map(route => (
					<Route
						key={route.slug}
						path={route.path}
						element={<Suspense>{route.component}</Suspense>}
					>
						{route.children?.map(child => (
							<Route
								key={child.slug}
								path={child.path}
								element={<Suspense>{child.component}</Suspense>}
							/>
						))}
					</Route>
				))}
			</Route>
		</Routes>
	)
}

export const AppRoutes = () => {
	return (
		<BrowserRouter basename="/app">
			<Routers />
		</BrowserRouter>
	)
}
